/**
 * The PIF screens render inside the portal shell, under its fixed 68px header
 * (`.header` in Header.scss, mirrored by `.main-content { margin-top }` in global.scss).
 * Sticky offsets and scroll targets have to clear it. Keep in sync with
 * `$pif-shell-header` in styles/_pif-tokens.scss.
 */
export const SHELL_HEADER_HEIGHT = 68;
